// Instância única: criar um Intl.NumberFormat por chamada é custoso e
// travava a renderização de listas grandes.
const numberFormat = new Intl.NumberFormat("pt-BR", {
  maximumFractionDigits: 2
});

export const formatQuantity = value => numberFormat.format(Number(value) || 0);
